<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Apps</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
    <div class="divider"></div>

    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showCreate"
      mat-button
      color="lightGreen"
      (click)="addNewApp()"
    >
      Add new app
    </button>
  </div>
</div>
<div class="apps">
  <div class="container template-list-container">
    <div class="container-header no-bottom-border">
      <div class="text">Linked apps</div>
      <div class="options" *ngIf="showCreate">
        <button mat-icon-button [matMenuTriggerFor]="appsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant vertical-menu" #appsMenu="matMenu">
          <button
            *ngIf="showCreate"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="addNewApp()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Add new app</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="container-content">
      <table #appsTable mat-table [dataSource]="appsDataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>App Name</th>
          <td mat-cell *matCellDef="let row">
            {{ row.name ? row.name : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="platform_names">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Platform(s)</th>
          <td mat-cell *matCellDef="let row">
            {{ row.platform_names ? row.platform_names : "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="applePushConfig">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Apple Push Config
          </th>
          <td mat-cell *matCellDef="let row">
            <svg-icon
              *ngIf="row.applePushConfig"
              src="assets/svg/check-green.svg"
            ></svg-icon>
            <svg-icon
              *ngIf="!row.applePushConfig"
              src="assets/svg/x-red.svg"
            ></svg-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="googleCloudConfig">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Google Cloud Config
          </th>
          <td mat-cell *matCellDef="let row">
            <svg-icon
              *ngIf="row.googleCloudConfig"
              src="assets/svg/check-green.svg"
            ></svg-icon>
            <svg-icon
              *ngIf="!row.googleCloudConfig"
              src="assets/svg/x-red.svg"
            ></svg-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="firebaseConfig">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Firebase Config
          </th>
          <td mat-cell *matCellDef="let row">
            <svg-icon
              *ngIf="row.firebaseConfig"
              src="assets/svg/check-green.svg"
            ></svg-icon>
            <svg-icon
              *ngIf="!row.firebaseConfig"
              src="assets/svg/x-red.svg"
            ></svg-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button
              *ngIf="showEdit"
              mat-button
              class="icon-btn"
              (click)="edit(row)"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showEdit" class="empty-btn-space"></div>

            <button
              *ngIf="showDelete && !isCurrentApp(row)"
              class="icon-btn"
              mat-button
              (click)="deleteApp(row)"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div
              *ngIf="!(showDelete && !isCurrentApp(row))"
              class="empty-btn-space"
            ></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator 
        [pageSizeOptions]="pageSizeOptions" 
        [pageSize]="perPage" 
        (page)="onPageChange($event)"
        ></mat-paginator>
    </div>
  </div>
</div>
